<template>
  <div class="book-actions" v-if="book" ref="actions">
    <span class="item" v-if="isAuthor" @click="editBook">
      <ui-icon name="icon-setting"></ui-icon>{{ $t("edit") }}
    </span>
    <span class="item" v-if="isAuthor" @click="viewInvite">
      <ui-icon name="team"></ui-icon>{{ $t("invite") }}
    </span>
    <pintop class="item" :book="book" v-if="isAuthor && authInfo.role !== 'user'"></pintop>
    <ui-popover class="item">
      <span slot="reference" class="pointer">
        <ui-icon name="link"></ui-icon>Share
      </span>
      <div class="share-list">
        <ui-share site="weibo" :data="weiboData">
          <ui-icon name="weibo"></ui-icon>{{ $t("weibo") }}
        </ui-share>
        <ui-share site="twitter" :data="twitterData">
          <ui-icon name="twitter"></ui-icon>{{ $t("twitter") }}
        </ui-share>
        <ui-share site="facebook" :data="facebookData">
          <ui-icon name="facebook"></ui-icon>{{ $t("facebook") }}
        </ui-share>
      </div>
    </ui-popover>
    <span class="item" @click="openWechat">
      <ui-icon name="weixin"></ui-icon>{{ $t("wechat") }}
    </span>
    <span class="item" v-if="book.cover" @click="openImage" v-ui-tooltip="{ content: $t('openImage'), insertAfter: false }">
      <ui-icon name="icon-zoomin" class="pointer"></ui-icon>
    </span>
    <ui-modal v-model="showInvite" :close-on-click="false" size="lg" :disable-scroll="false">
      <div slot="header">{{ $t("invite") }}</div>
      <invite :book="book" ref="invite" :authInfo="authInfo" @send-success="showInvite = false" @close="showInvite = false"></invite>
      <div slot="footer">
        <ui-button-group>
          <ui-button type="border" @click.native="showInvite = false">{{
            $t("cancel")
            }}</ui-button>
          <ui-button @click.native="$refs.invite.sendInvites">{{
            $t("sendInvite")
            }}</ui-button>
        </ui-button-group>
      </div>
    </ui-modal>
    <ui-modal v-model="showWechat" :show-close-icon="false" custom-class="wechat-modal">
      <poster :book="book" :link="link"></poster>
    </ui-modal>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import Invite from "../invite.vue";
import Pintop from "../Pintop.vue";
import api from "../../api/index.js";
import Poster from '../poster.vue'
export default {
  name: "BookActions",

  data() {
    return {
      contactList: [],
      showInvite: false,
      weiboData: {
        url: this.link,
        title: this.book.title,
        image: this.book.cover[0],
        appkey: "79491122"
      },
      twitterData: {
        url: this.link,
        title: this.book.title
      },
      facebookData: {
        url: this.link
      },
      qrcode: '',
      showWechat: false
    };
  },
  computed: {
    ...mapGetters(["authInfo"]),
    isAuthor() {
      return this.authInfo && this.authInfo.id === this.book.userInfo.id;
    }
  },
  components: {
    Pintop,
    Invite,
    Poster
  },
  props: {
    book: Object,
    link: String,
    coverIndex: Number
  },
  methods: {
    openWechat() {
      this.showWechat = true
    },
    share(target) {},
    openImage() {
      window.open(this.book.cover[this.coverIndex]);
    },
    editBook() {
      let bookId = this.book.id;
      this.$router.push("/editBook/" + bookId);
    },
    viewInvite() {
      this.showInvite = true;
    },
    getQrcode() {

    }
  }
};

</script>
